import { useTranslation } from 'next-i18next'

const EsgPage = (): React.ReactElement => {
  const { t } = useTranslation('donation')
  return (
    <section className="flex flex-col items-center md:pt-5 mb-11">
      <h1 className="w-64 text-center text-white font-bold leading-9 tracking-widest text-shadow-donation text-h3">
        {t('esg.label')}
      </h1>
      <div className="w-78 md:w-152 p-2 text-white text-xs md:text-sm text-left md:text-center tracking-btn-wide font-features leading-7 font-light mt-3 whitespace-pre-line space-y-8">
        <p>{t('esg.descriptionFirstPart')}</p>
        <p>{t('esg.descriptionSecondPart')}</p>
        <p>{t('esg.descriptionThirdPart')}</p>
        <p>{t('esg.descriptionFourthPart')}</p>
      </div>
    </section>
  )
}

export default EsgPage
